/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ArtistRemixContestEndingSoonNotificationAction } from './ArtistRemixContestEndingSoonNotificationAction';
import {
    ArtistRemixContestEndingSoonNotificationActionFromJSON,
    ArtistRemixContestEndingSoonNotificationActionFromJSONTyped,
    ArtistRemixContestEndingSoonNotificationActionToJSON,
} from './ArtistRemixContestEndingSoonNotificationAction';

/**
 * 
 * @export
 * @interface ArtistRemixContestEndingSoonNotification
 */
export interface ArtistRemixContestEndingSoonNotification {
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestEndingSoonNotification
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ArtistRemixContestEndingSoonNotification
     */
    groupId: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArtistRemixContestEndingSoonNotification
     */
    isSeen: boolean;
    /**
     * 
     * @type {number}
     * @memberof ArtistRemixContestEndingSoonNotification
     */
    seenAt?: number;
    /**
     * 
     * @type {Array<ArtistRemixContestEndingSoonNotificationAction>}
     * @memberof ArtistRemixContestEndingSoonNotification
     */
    actions: Array<ArtistRemixContestEndingSoonNotificationAction>;
}

/**
 * Check if a given object implements the ArtistRemixContestEndingSoonNotification interface.
 */
export function instanceOfArtistRemixContestEndingSoonNotification(value: object): value is ArtistRemixContestEndingSoonNotification {
    let isInstance = true;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "groupId" in value && value["groupId"] !== undefined;
    isInstance = isInstance && "isSeen" in value && value["isSeen"] !== undefined;
    isInstance = isInstance && "actions" in value && value["actions"] !== undefined;

    return isInstance;
}

export function ArtistRemixContestEndingSoonNotificationFromJSON(json: any): ArtistRemixContestEndingSoonNotification {
    return ArtistRemixContestEndingSoonNotificationFromJSONTyped(json, false);
}

export function ArtistRemixContestEndingSoonNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtistRemixContestEndingSoonNotification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'groupId': json['group_id'],
        'isSeen': json['is_seen'],
        'seenAt': !exists(json, 'seen_at') ? undefined : json['seen_at'],
        'actions': ((json['actions'] as Array<any>).map(ArtistRemixContestEndingSoonNotificationActionFromJSON)),
    };
}

export function ArtistRemixContestEndingSoonNotificationToJSON(value?: ArtistRemixContestEndingSoonNotification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'group_id': value.groupId,
        'is_seen': value.isSeen,
        'seen_at': value.seenAt,
        'actions': ((value.actions as Array<any>).map(ArtistRemixContestEndingSoonNotificationActionToJSON)),
    };
}

